<template src="./login-multi.html"></template>

<script>
import Vue from 'vue'
import { isUserActive, login } from '@/router/auth'
import { validationMixin } from '@/mixins/validation'
import { required } from 'vuelidate/lib/validators'
import Vuelidate from 'vuelidate'
import AlertContainer from '@/components/header/alert-container/AlertContainer.vue'

Vue.use(Vuelidate)

export default {
  mixins: [validationMixin],
  components: { AlertContainer },
  name: 'login-multi',
  data () {
    return {
      loading: false,
      model: 'tab-2',
      tabs: null,
      user: {
        login: '',
        password: ''
      }
    }
  },
  mounted () {
    if (isUserActive()) {
      this.goToDash()
    } else {
      this.$nextTick(() => this.$refs.usernameInput.focus())
    }
  },
  created () {
    this.$nextTick(() => this.$refs.usernameInput.focus())
  },
  computed: {
    loginErrors () {
      return !this.$v.user.login.$dirty ? [] : this.getUserValidationErrorsByName('login')
    },
    passwordErrors () {
      return !this.$v.user.password.$dirty ? [] : this.getUserValidationErrorsByName('password')
    }
  },
  methods: {
    getUserValidationErrorsByName (name) {
      return this.getValidationErrors('user').filter((x) => { return x.field === name }).map(x => x.msg)
    },
    validateBeforeLogin () {
      this.$v.$touch()
      const validationErrors = this.getValidationErrors('user')
      if (validationErrors && validationErrors.length > 0) {
        return
      }

      this.login(true)
    },
    validateBeforeLoginAd () {
      this.$v.$touch()
      const validationErrors = this.getValidationErrors('user')
      if (validationErrors && validationErrors.length > 0) {
        return
      }

      this.login(false)
    },
    login (standardLogin) {
      this.loading = true
      const loginUrl = standardLogin ? Vue.$apiConfig.login : Vue.$apiConfig.loginAd
      this.$http.post(loginUrl, this.user).then(
        response => {
          const payload = response.data.payload
          login(this.user.login, payload.accessToken, payload.refreshToken)
          this.loading = false
          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect)
          } else {
            this.goToDash()
          }
        },
        error => {
          this.loading = false
          this.logConsole(error)
          this.formatErrorResponse(error)
        })
    },
    gotoRegister () {
      this.$router.push('/register-organization')
    },
    forgottenPassword () {
      this.$router.push('/login/password-reset')
    },
    initialLogin () {
      this.$router.push('/login/initial')
    },
    goToDash () {
      this.$router.push('/dashboard')
    }
  },
  validations: {
    user: {
      login: {
        required
      },
      password: {
        required
      }
    }
  }
}
</script>
